// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2NHvK","title":"Info_title__3Pw_N","links":"Info_links__efxuL","link":"Info_link__2QFYe","logo":"Info_logo__35h-e"};